import styled from "styled-components";

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space[3]};
  padding: ${({ theme }) => `${theme.space[3]} ${theme.space[3]}`};
  border: ${({ theme }) => theme.borders[2]};
  border-radius: ${({ theme }) => theme.radii[3]};
  height: stretch;
`;

export const DeadlineDateTimeWrapper = styled.div`
  padding: ${({ theme }) => `${theme.space[2]} ${theme.space[3]}`};
  background-color: ${({ theme }) => theme.colors.white4};
  border: ${({ theme }) => theme.borders[2]};
  border-radius: ${({ theme }) => theme.radii[4]};
`;

export const RoundTitle = styled.h3`
  margin: 0;
  line-height: 1;
  font-size: ${({ theme }) => theme.fontSizes[5]};
  text-align: center;
`;
